module.exports = __webpack_public_path__ + "static/media/MenuGrilledCheese.3ece4346.jpg";